module.exports = __webpack_public_path__ + "196384ee0ce16afa2888e6ed7d47c52f.png";